import { PHONE_PREFIXES } from '@/domains/partners/multisport/const/PhonePrefixes.const'

export const usePhonePrefixes = () => {
  const { t } = useI18n()
  return PHONE_PREFIXES.map((phonePrefix: { text: string; value: string }) => ({
    ...phonePrefix,
    text: t(phonePrefix.text),
  }))
}
